import { MenuItem } from '../../ui/dtos/menu-item';
import { core } from '../../ui/side-nav/core-menu-items';

export function getPaygMenuItems(): MenuItem[] {
  return [
    core.transactionsMenuItem,
    core.entitiesMenuItem,
    core.projectsMenuItem,
    core.certificatesMenuItem,
    core.usersMenuItem,
    core.exportMenuItem,
    core.surveysMenuItem,
    core.auditMenuItem,
  ];
}
